import { FILTER_KEYS } from './reconciliationHealth'

export function getFilterStorageKey(venueId) {
  return `receipting_filter_${venueId}`
}

export function getBannerDismissStorageKey(venueId) {
  return `receipting_health_banner_dismissed_${venueId}`
}

export function getHealthPanelStorageKey(venueId) {
  return `receipting_health_panel_open_${venueId}`
}

export function getStoredHealthPanelOpen(venueId) {
  if (!venueId || typeof localStorage === 'undefined') return null
  const value = localStorage.getItem(getHealthPanelStorageKey(venueId))
  if (value === null) return null
  return value === '1'
}

export function setStoredHealthPanelOpen(venueId, isOpen) {
  if (!venueId || typeof localStorage === 'undefined') return
  localStorage.setItem(getHealthPanelStorageKey(venueId), isOpen ? '1' : '0')
}

export function resolveInitialHealthPanelOpen(
  venueId,
  { needsAction = 0, total = 0 } = {},
) {
  const stored = getStoredHealthPanelOpen(venueId)
  if (stored !== null) return stored

  if (needsAction > 0) return false
  if (total > 0) return true
  return false
}

export function getStoredStatusFilter(venueId) {
  if (!venueId || typeof sessionStorage === 'undefined') return null
  const value = sessionStorage.getItem(getFilterStorageKey(venueId))
  if (!value) return null
  return Object.values(FILTER_KEYS).includes(value) ? value : null
}

export function setStoredStatusFilter(venueId, filterKey) {
  if (!venueId || typeof sessionStorage === 'undefined') return
  sessionStorage.setItem(getFilterStorageKey(venueId), filterKey)
}

export function isHealthBannerDismissed(venueId) {
  if (!venueId || typeof sessionStorage === 'undefined') return false
  return sessionStorage.getItem(getBannerDismissStorageKey(venueId)) === '1'
}

export function dismissHealthBanner(venueId) {
  if (!venueId || typeof sessionStorage === 'undefined') return
  sessionStorage.setItem(getBannerDismissStorageKey(venueId), '1')
}

/**
 * Default Goods Receipting filter when there is no URL deep-link.
 * No status chip is selected, so the date range shows every order.
 * URL `?filter=` still wins.
 */
export function resolveInitialStatusFilter() {
  return FILTER_KEYS.ALL
}
